import { DesktopShell } from "@circleco/compass/components/DesktopShell";
import { type PropsWithChildren } from "react";

import type { ShellLayoutContextValue } from "./context";

export const CompassRoot = ({
  children,
  dockMode,
  conversationPanelState,
  conversationPanelWidth,
  isLeftSidebarVisible,
  leftSidebarWidth,
  isRightSidebarVisible,
  rightSidebarWidth,
  onConversationPanelWidthChange,
}: Readonly<PropsWithChildren<ShellLayoutContextValue>>) => (
  <DesktopShell.Root
    data-testid="circle-ai-shell-layout-root"
    dockMode={dockMode}
    conversationPanelState={conversationPanelState}
    conversationPanelWidth={conversationPanelWidth}
    isSidebarVisible={isLeftSidebarVisible}
    sidebarWidth={leftSidebarWidth}
    isPanelVisible={isRightSidebarVisible}
    panelWidth={rightSidebarWidth}
    onConversationPanelWidthChange={onConversationPanelWidthChange}
  >
    {children}
  </DesktopShell.Root>
);

CompassRoot.displayName = "CircleAIAppShell.Layout";
